module.exports = __webpack_public_path__ + "img/Rheinland_Certified_PCIDSS.1ff6aa48.png";